module.exports = __webpack_public_path__ + "static/media/mail.6807e878.svg";